export type ButtonSize = 'sm' | 'md' | 'lg'

const BASE =
  'group inline-flex items-center justify-center gap-2.5 rounded-[8px] bg-ember text-center font-sans font-bold uppercase text-white shadow-[0_14px_28px_-14px_rgba(214,90,22,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-ember-deep active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-olive-light/70'

const SIZES: Record<ButtonSize, string> = {
  sm: 'min-h-[46px] whitespace-nowrap px-4 text-[0.85rem] tracking-[0.04em]',
  md: 'min-h-[52px] whitespace-nowrap px-6 text-[0.95rem] tracking-[0.04em]',
  // Long labels balance onto two lines on narrow phones instead of overflowing.
  lg: 'min-h-[58px] max-w-full px-5 py-3 text-[0.95rem] leading-tight tracking-[0.03em] text-balance sm:px-8 sm:text-[1.02rem] sm:tracking-[0.04em]',
}

/** Primary burnt-orange button classes, shared by purchase and scroll CTAs. */
export function primaryButtonClass(size: ButtonSize = 'md'): string {
  return `${BASE} ${SIZES[size]}`
}
